import { queryOptions } from '@tanstack/react-query';
import type { ApiFinanceiroConta } from '@/features/financeiro-conta/types/ApiFinanceiroConta';
import type { DefaultApiParams } from '@/std/pagination/types';
import { fetchApi } from '@/std/api/fetchApi';

export type ApiFinanceiroContaGetParams = Partial<
    DefaultApiParams & {
        tipo_conta: 'C' | 'B' | 'P';
        conta_padrao: 'S';
    }
>;

// Para consultar a conta do pixapay utilizar o endpoint Fintech/ContaConsultar

async function apiFinanceiroContaGet(params?: ApiFinanceiroContaGetParams) {
    const response = await fetchApi({
        endpoint: 'FinanceiroConta/FinanceiroConta',
        method: 'get',
        params,
        schema: null,
    });

    return response as {
        registros: ApiFinanceiroConta[];
        total_registros?: number;
    };
}

export const API_FINANCEIRO_CONTA_GET = 'apiFinanceiroContaGet';

export function apiFinanceiroContaGetQueryOptions(params?: ApiFinanceiroContaGetParams) {
    return queryOptions({
        queryFn: () => apiFinanceiroContaGet(params),
        queryKey: [API_FINANCEIRO_CONTA_GET, params],
    });
}
